import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import * as ROUTES from 'constants/paths';

import { insertCode } from 'helpers/path';

import { INavigateToErrorPageProps } from './types';

export const NavigateToErrorPage: FC<INavigateToErrorPageProps> = ({
  errorCode = 'default',
  replace = false,
}) => (
  <Navigate to={insertCode(ROUTES.ERROR, errorCode)} replace={replace} />
);
